import { render, staticRenderFns } from "./farmersDetail.vue?vue&type=template&id=33b6ab3b&scoped=true"
import script from "./farmersDetail.vue?vue&type=script&lang=js"
export * from "./farmersDetail.vue?vue&type=script&lang=js"
import style0 from "./farmersDetail.vue?vue&type=style&index=0&id=33b6ab3b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6ab3b",
  null
  
)

export default component.exports